'use client';

import React from 'react';
import { openCookieSettings } from '@/utility/consent/cookieConsent';

interface CookieSettingsLinkProps {
  className?: string;
}

const CookieSettingsLink: React.FC<CookieSettingsLinkProps> = ({
  className = '',
}) => (
  <button
    type="button"
    onClick={openCookieSettings}
    className={`text-[13px] text-gray-500 underline hover:text-primary ${className}`}
  >
    Cookie settings
  </button>
);

export default CookieSettingsLink;
